module.exports = __webpack_public_path__ + "img/partner-1.d68e964f.png";